export const countries = [
  {
    code: 'AF',
    country: 'Afghanistan',
    phone: '+93',
  },
  {
    code: 'ZA',
    country: 'Afrique du Sud',
    phone: '+27',
  },
  {
    code: 'AL',
    country: 'Albanie',
    phone: '+355',
  },
  {
    code: 'DZ',
    country: 'Algérie',
    phone: '+213',
  },
  {
    code: 'DE',
    country: 'Allemagne',
    phone: '+49',
  },
  {
    code: 'AD',
    country: 'Andorre',
    phone: '+376',
  },
  {
    code: 'AO',
    country: 'Angola',
    phone: '+244',
  },
  {
    code: 'AI',
    country: 'Anguilla',
    phone: '+1264',
  },
  {
    code: 'AG',
    country: 'Antigua-et-Barbuda',
    phone: '+1268',
  },
  {
    code: 'AR',
    country: 'Argentine',
    phone: '+54',
  },
  {
    code: 'AM',
    country: 'Arménie',
    phone: '+374',
  },
  {
    code: 'AW',
    country: 'Aruba',
    phone: '+297',
  },
  {
    code: 'AU',
    country: 'Australie',
    phone: '+61',
  },
  {
    code: 'AT',
    country: 'Autriche',
    phone: '+43',
  },
  {
    code: 'AZ',
    country: 'Azerbaïdjan',
    phone: '+994',
  },
  {
    code: 'BS',
    country: 'Bahamas',
    phone: '+1242',
  },
  {
    code: 'BH',
    country: 'Bahreïn',
    phone: '+973',
  },
  {
    code: 'BD',
    country: 'Bangladesh',
    phone: '+880',
  },
  {
    code: 'BB',
    country: 'Barbade',
    phone: '+1246',
  },
  {
    code: 'BE',
    country: 'Belgique',
    phone: '+32',
  },
  {
    code: 'BZ',
    country: 'Belize',
    phone: '+501',
  },
  {
    code: 'BJ',
    country: 'Bénin',
    phone: '+229',
  },
  {
    code: 'BM',
    country: 'Bermudes',
    phone: '+1441',
  },
  {
    code: 'BT',
    country: 'Bhoutan',
    phone: '+975',
  },
  {
    code: 'BY',
    country: 'Biélorussie',
    phone: '+375',
  },
  {
    code: 'BO',
    country: 'Bolivie',
    phone: '+591',
  },
  {
    code: 'BA',
    country: 'Bosnie-Herzégovine',
    phone: '+387',
  },
  {
    code: 'BW',
    country: 'Botswana',
    phone: '+267',
  },
  {
    code: 'BR',
    country: 'Brésil',
    phone: '+55',
  },
  {
    code: 'BN',
    country: 'Brunei',
    phone: '+673',
  },
  {
    code: 'BG',
    country: 'Bulgarie',
    phone: '+359',
  },
  {
    code: 'BF',
    country: 'Burkina Faso',
    phone: '+226',
  },
  {
    code: 'BI',
    country: 'Burundi',
    phone: '+257',
  },
  {
    code: 'KH',
    country: 'Cambodge',
    phone: '+855',
  },
  {
    code: 'CM',
    country: 'Cameroun',
    phone: '+237',
  },
  {
    code: 'CA',
    country: 'Canada',
    phone: '+1',
  },
  {
    code: 'CV',
    country: 'Cap-Vert',
    phone: '+238',
  },
  {
    code: 'KY',
    country: 'Îles Caïmans',
    phone: '+1345',
  },
  {
    code: 'CL',
    country: 'Chili',
    phone: '+56',
  },
  {
    code: 'CN',
    country: 'Chine',
    phone: '+86',
  },
  {
    code: 'CY',
    country: 'Chypre',
    phone: '+357',
  },
  {
    code: 'CO',
    country: 'Colombie',
    phone: '+57',
  },
  {
    code: 'KM',
    country: 'Comores',
    phone: '+269',
  },
  {
    code: 'CG',
    country: 'Congo',
    phone: '+242',
  },
  {
    code: 'CD',
    country: 'République démocratique du Congo',
    phone: '+243',
  },
  {
    code: 'CR',
    country: 'Costa Rica',
    phone: '+506',
  },
  {
    code: 'CI',
    country: "Côte d'Ivoire",
    phone: '+225',
  },
  {
    code: 'HR',
    country: 'Croatie',
    phone: '+385',
  },
  {
    code: 'CU',
    country: 'Cuba',
    phone: '+53',
  },
  {
    code: 'CW',
    country: 'Curaçao',
    phone: '+599',
  },
  {
    code: 'DK',
    country: 'Danemark',
    phone: '+45',
  },
  {
    code: 'DJ',
    country: 'Djibouti',
    phone: '+253',
  },
  {
    code: 'DM',
    country: 'Dominique',
    phone: '+1767',
  },
  {
    code: 'DO',
    country: 'République dominicaine',
    phone: '+1809',
  },
  {
    code: 'EG',
    country: 'Égypte',
    phone: '+20',
  },
  {
    code: 'AE',
    country: 'Émirats arabes unis',
    phone: '+971',
  },
  {
    code: 'EC',
    country: 'Équateur',
    phone: '+593',
  },
  {
    code: 'ER',
    country: 'Érythrée',
    phone: '+291',
  },
  {
    code: 'ES',
    country: 'Espagne',
    phone: '+34',
  },
  {
    code: 'EE',
    country: 'Estonie',
    phone: '+372',
  },
  {
    code: 'SZ',
    country: 'Eswatini',
    phone: '+268',
  },
  {
    code: 'US',
    country: 'États-Unis',
    phone: '+1',
  },
  {
    code: 'ET',
    country: 'Éthiopie',
    phone: '+251',
  },
  {
    code: 'FJ',
    country: 'Fidji',
    phone: '+679',
  },
  {
    code: 'FI',
    country: 'Finlande',
    phone: '+358',
  },
  {
    code: 'FR',
    country: 'France',
    phone: '+33',
  },
  {
    code: 'GA',
    country: 'Gabon',
    phone: '+241',
  },
  {
    code: 'GM',
    country: 'Gambie',
    phone: '+220',
  },
  {
    code: 'GE',
    country: 'Géorgie',
    phone: '+995',
  },
  {
    code: 'GH',
    country: 'Ghana',
    phone: '+233',
  },
  {
    code: 'GR',
    country: 'Grèce',
    phone: '+30',
  },
  {
    code: 'GD',
    country: 'Grenade',
    phone: '+1473',
  },
  {
    code: 'GT',
    country: 'Guatemala',
    phone: '+502',
  },
  {
    code: 'GN',
    country: 'Guinée',
    phone: '+224',
  },
  {
    code: 'GQ',
    country: 'Guinée équatoriale',
    phone: '+240',
  },
  {
    code: 'GW',
    country: 'Guinée-Bissau',
    phone: '+245',
  },
  {
    code: 'GY',
    country: 'Guyana',
    phone: '+592',
  },
  {
    code: 'HT',
    country: 'Haïti',
    phone: '+509',
  },
  {
    code: 'HN',
    country: 'Honduras',
    phone: '+504',
  },
  {
    code: 'HK',
    country: 'Hong Kong',
    phone: '+852',
  },
  {
    code: 'HU',
    country: 'Hongrie',
    phone: '+36',
  },
  {
    code: 'IS',
    country: 'Islande',
    phone: '+354',
  },
  {
    code: 'IN',
    country: 'Inde',
    phone: '+91',
  },
  {
    code: 'ID',
    country: 'Indonésie',
    phone: '+62',
  },
  {
    code: 'IR',
    country: 'Iran',
    phone: '+98',
  },
  {
    code: 'IQ',
    country: 'Irak',
    phone: '+964',
  },
  {
    code: 'IE',
    country: 'Irlande',
    phone: '+353',
  },
  {
    code: 'IL',
    country: 'Israël',
    phone: '+972',
  },
  {
    code: 'IT',
    country: 'Italie',
    phone: '+39',
  },
  {
    code: 'JM',
    country: 'Jamaïque',
    phone: '+1876',
  },
  {
    code: 'JP',
    country: 'Japon',
    phone: '+81',
  },
  {
    code: 'JO',
    country: 'Jordanie',
    phone: '+962',
  },
  {
    code: 'KZ',
    country: 'Kazakhstan',
    phone: '+7',
  },
  {
    code: 'KE',
    country: 'Kenya',
    phone: '+254',
  },
  {
    code: 'KI',
    country: 'Kiribati',
    phone: '+686',
  },
  {
    code: 'KW',
    country: 'Koweït',
    phone: '+965',
  },
  {
    code: 'KG',
    country: 'Kirghizistan',
    phone: '+996',
  },
  {
    code: 'LA',
    country: 'Laos',
    phone: '+856',
  },
  {
    code: 'LV',
    country: 'Lettonie',
    phone: '+371',
  },
  {
    code: 'LB',
    country: 'Liban',
    phone: '+961',
  },
  {
    code: 'LS',
    country: 'Lesotho',
    phone: '+266',
  },
  {
    code: 'LR',
    country: 'Libéria',
    phone: '+231',
  },
  {
    code: 'LY',
    country: 'Libye',
    phone: '+218',
  },
  {
    code: 'LI',
    country: 'Liechtenstein',
    phone: '+423',
  },
  {
    code: 'LT',
    country: 'Lituanie',
    phone: '+370',
  },
  {
    code: 'LU',
    country: 'Luxembourg',
    phone: '+352',
  },
  {
    code: 'MO',
    country: 'Macao',
    phone: '+853',
  },
  {
    code: 'MK',
    country: 'Macédoine du Nord',
    phone: '+389',
  },
  {
    code: 'MG',
    country: 'Madagascar',
    phone: '+261',
  },
  {
    code: 'MW',
    country: 'Malawi',
    phone: '+265',
  },
  {
    code: 'MY',
    country: 'Malaisie',
    phone: '+60',
  },
  {
    code: 'MV',
    country: 'Maldives',
    phone: '+960',
  },
  {
    code: 'ML',
    country: 'Mali',
    phone: '+223',
  },
  {
    code: 'MT',
    country: 'Malte',
    phone: '+356',
  },
  {
    code: 'MR',
    country: 'Mauritanie',
    phone: '+222',
  },
  {
    code: 'MU',
    country: 'Maurice',
    phone: '+230',
  },
  {
    code: 'MX',
    country: 'Mexique',
    phone: '+52',
  },
  {
    code: 'FM',
    country: 'Micronésie',
    phone: '+691',
  },
  {
    code: 'MD',
    country: 'Moldavie',
    phone: '+373',
  },
  {
    code: 'MC',
    country: 'Monaco',
    phone: '+377',
  },
  {
    code: 'MN',
    country: 'Mongolie',
    phone: '+976',
  },
  {
    code: 'ME',
    country: 'Monténégro',
    phone: '+382',
  },
  {
    code: 'MA',
    country: 'Maroc',
    phone: '+212',
  },
  {
    code: 'MZ',
    country: 'Mozambique',
    phone: '+258',
  },
  {
    code: 'MM',
    country: 'Myanmar (Birmanie)',
    phone: '+95',
  },
  {
    code: 'NA',
    country: 'Namibie',
    phone: '+264',
  },
  {
    code: 'NR',
    country: 'Nauru',
    phone: '+674',
  },
  {
    code: 'NP',
    country: 'Népal',
    phone: '+977',
  },
  {
    code: 'NL',
    country: 'Pays-Bas',
    phone: '+31',
  },
  {
    code: 'NZ',
    country: 'Nouvelle-Zélande',
    phone: '+64',
  },
  {
    code: 'NI',
    country: 'Nicaragua',
    phone: '+505',
  },
  {
    code: 'NE',
    country: 'Niger',
    phone: '+227',
  },
  {
    code: 'NG',
    country: 'Nigeria',
    phone: '+234',
  },
  {
    code: 'KP',
    country: 'Corée du Nord',
    phone: '+850',
  },
  {
    code: 'NO',
    country: 'Norvège',
    phone: '+47',
  },
  {
    code: 'OM',
    country: 'Oman',
    phone: '+968',
  },
  {
    code: 'UG',
    country: 'Ouganda',
    phone: '+256',
  },
  {
    code: 'UZ',
    country: 'Ouzbékistan',
    phone: '+998',
  },
  {
    code: 'PK',
    country: 'Pakistan',
    phone: '+92',
  },
  {
    code: 'PW',
    country: 'Palaos',
    phone: '+680',
  },
  {
    code: 'PA',
    country: 'Panama',
    phone: '+507',
  },
  {
    code: 'PG',
    country: 'Papouasie-Nouvelle-Guinée',
    phone: '+675',
  },
  {
    code: 'PY',
    country: 'Paraguay',
    phone: '+595',
  },
  {
    code: 'PE',
    country: 'Pérou',
    phone: '+51',
  },
  {
    code: 'PH',
    country: 'Philippines',
    phone: '+63',
  },
  {
    code: 'PL',
    country: 'Pologne',
    phone: '+48',
  },
  {
    code: 'PT',
    country: 'Portugal',
    phone: '+351',
  },
  {
    code: 'QA',
    country: 'Qatar',
    phone: '+974',
  },
  {
    code: 'RO',
    country: 'Roumanie',
    phone: '+40',
  },
  {
    code: 'GB',
    country: 'Royaume-Uni',
    phone: '+44',
  },
  {
    code: 'RU',
    country: 'Russie',
    phone: '+7',
  },
  {
    code: 'RW',
    country: 'Rwanda',
    phone: '+250',
  },
  {
    code: 'KN',
    country: 'Saint-Christophe-et-Niévès',
    phone: '+1869',
  },
  {
    code: 'LC',
    country: 'Sainte-Lucie',
    phone: '+1758',
  },
  {
    code: 'VC',
    country: 'Saint-Vincent-et-les-Grenadines',
    phone: '+1784',
  },
  {
    code: 'WS',
    country: 'Samoa',
    phone: '+685',
  },
  {
    code: 'SM',
    country: 'Saint-Marin',
    phone: '+378',
  },
  {
    code: 'ST',
    country: 'Sao Tomé-et-Principe',
    phone: '+239',
  },
  {
    code: 'SA',
    country: 'Arabie saoudite',
    phone: '+966',
  },
  {
    code: 'SN',
    country: 'Sénégal',
    phone: '+221',
  },
  {
    code: 'RS',
    country: 'Serbie',
    phone: '+381',
  },
  {
    code: 'SC',
    country: 'Seychelles',
    phone: '+248',
  },
  {
    code: 'SL',
    country: 'Sierra Leone',
    phone: '+232',
  },
  {
    code: 'SG',
    country: 'Singapour',
    phone: '+65',
  },
  {
    code: 'SX',
    country: 'Saint-Martin (partie néerlandaise)',
    phone: '+1721',
  },
  {
    code: 'SK',
    country: 'Slovaquie',
    phone: '+421',
  },
  {
    code: 'SI',
    country: 'Slovénie',
    phone: '+386',
  },
  {
    code: 'SO',
    country: 'Somalie',
    phone: '+252',
  },
  {
    code: 'SD',
    country: 'Soudan',
    phone: '+249',
  },
  {
    code: 'SS',
    country: 'Soudan du Sud',
    phone: '+211',
  },
  {
    code: 'LK',
    country: 'Sri Lanka',
    phone: '+94',
  },
  {
    code: 'SE',
    country: 'Suède',
    phone: '+46',
  },
  {
    code: 'CH',
    country: 'Suisse',
    phone: '+41',
  },
  {
    code: 'SR',
    country: 'Suriname',
    phone: '+597',
  },
  {
    code: 'SY',
    country: 'Syrie',
    phone: '+963',
  },
  {
    code: 'TJ',
    country: 'Tadjikistan',
    phone: '+992',
  },
  {
    code: 'TZ',
    country: 'Tanzanie',
    phone: '+255',
  },
  {
    code: 'TD',
    country: 'Tchad',
    phone: '+235',
  },
  {
    code: 'CZ',
    country: 'Tchéquie',
    phone: '+420',
  },
  {
    code: 'TH',
    country: 'Thaïlande',
    phone: '+66',
  },
  {
    code: 'TL',
    country: 'Timor oriental',
    phone: '+670',
  },
  {
    code: 'TG',
    country: 'Togo',
    phone: '+228',
  },
  {
    code: 'TO',
    country: 'Tonga',
    phone: '+676',
  },
  {
    code: 'TT',
    country: 'Trinité-et-Tobago',
    phone: '+1868',
  },
  {
    code: 'TN',
    country: 'Tunisie',
    phone: '+216',
  },
  {
    code: 'TM',
    country: 'Turkménistan',
    phone: '+993',
  },
  {
    code: 'TR',
    country: 'Turquie',
    phone: '+90',
  },
  {
    code: 'TV',
    country: 'Tuvalu',
    phone: '+688',
  },
  {
    code: 'UA',
    country: 'Ukraine',
    phone: '+380',
  },
  {
    code: 'UY',
    country: 'Uruguay',
    phone: '+598',
  },
  {
    code: 'VU',
    country: 'Vanuatu',
    phone: '+678',
  },
  {
    code: 'VA',
    country: 'Vatican',
    phone: '+379',
  },
  {
    code: 'VE',
    country: 'Venezuela',
    phone: '+58',
  },
  {
    code: 'VN',
    country: 'Viêt Nam',
    phone: '+84',
  },
  {
    code: 'YE',
    country: 'Yémen',
    phone: '+967',
  },
  {
    code: 'ZM',
    country: 'Zambie',
    phone: '+260',
  },
  {
    code: 'ZW',
    country: 'Zimbabwe',
    phone: '+263',
  },
];
